import * as React from "react";
import {
  createTheme,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";

interface InputProps {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  id?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement> & {
    [key: string]: any;
  };
  placeholder?: string;
  img?: string;
  width?: string | number;
  applyMask?: boolean;
  maskFunction?: (value: string) => string;
  inputStyle?: React.CSSProperties;
  maxLength?: number;
  onInput?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputRef?: React.Ref<HTMLInputElement>;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const Input = ({
  label,
  value,
  onChange,
  onBlur,
  inputProps,
  placeholder,
  img,
  width,
  applyMask = false,
  maskFunction,
  inputStyle,
  maxLength,
  onInput,
  inputRef,
  onKeyDown,
  disabled = false,
}: InputProps) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const customTheme = createTheme({
    palette: {
      primary: {
        main: "#000000",
      },
    },
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;

    if (applyMask && maskFunction) {
      newValue = maskFunction(newValue);
    }
    onChange({
      ...event,
      target: {
        ...event.target,
        value: newValue,
      },
    });
  };

  return (
    <div>
      <ThemeProvider theme={customTheme}>
        <TextField
          id="filled-basic"
          label={label}
          variant="filled"
          value={value}
          onChange={handleChange}
          onBlur={() => {
            setIsFocused(false);
            if (onBlur) onBlur();
          }}
          onFocus={() => setIsFocused(true)}
          inputProps={{ ...inputProps, maxLength: maxLength }}
          placeholder={placeholder}
          sx={{
            "& > :not(style)": { width: width },
            "& .MuiFilledInput-root": {
              display: "flex",
              fontSize: "15px",
              height: "50px",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: isFocused ? "#E0E2E5" : "transparent",
              padding: "12px",
              fontSize: "15px",
              ...inputStyle,
            },
            "& .MuiInputLabel-root": {
              fontWeight: "400",
              fontSize: "15px",
            },
          }}
          focused
          InputProps={{
            endAdornment: img ? (
              <InputAdornment
                position="end"
                sx={{
                  borderRadius: "0 4px 4px 0",
                  width: "30px",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={img}
                  alt="icon"
                  style={{
                    width: "20px",
                    height: "20px",
                    objectFit: "contain",
                  }}
                />
              </InputAdornment>
            ) : null,
          }}
          onInput={onInput}
          inputRef={inputRef}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
      </ThemeProvider>
    </div>
  );
};

export default Input;
